var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"undo-summary"},[_c('ul',[_c('li',[_vm._v("Se intentará revertir invitados creados y actualizados de esta importación.")]),_c('li',[_vm._v("No se revertirán invitados con actividad posterior o conflictos de datos.")]),_c('li',[_vm._v("El resultado puede ser total o parcial según reglas de seguridad.")])])])
}]

export { render, staticRenderFns }